
<template>
    <b-col>
		<figure class="figure">
        <router-link class="d-block mb-1 h-100" :to="'/video/' + id">
        <b-img fluid class="img-thumbnail" :src="logo" alt=""></b-img></router-link>
    <figcaption v-if="name.length<30" class="text-left figure-caption">{{ name }}</figcaption>
        <figcaption v-else class="text-left figure-caption">{{ name.substring(0,30)+"..." }}</figcaption>
    </figure>
  </b-col>

</template>

<script>
    export default {
        name: "Highlight.vue",
        props:['id','bio','video_url','name','logo','description']
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Highlight.vue